import SettingsIcon from '@mui/icons-material/Settings';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import React from 'react';

import theme from '../../theme';

export default function MaintenancePage() {
  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
        px: 2,
        backgroundColor: theme.palette.primary.main,
        color: 'white',
      }}
    >
      {/* Static logo */}
      <img src="/logo-light.png" alt="Logo" style={{ width: 400, marginBottom: 80 }} />

      {/* Spinning gear */}
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 8, ease: 'linear' }}
        style={{ marginBottom: '1.5rem' }}
      >
        <SettingsIcon sx={{ fontSize: 80 }} />
      </motion.div>

      <Typography variant="h4" component="h1" gutterBottom>
        Hey there, we’re tinkering under the hood…
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, maxWidth: 400 }}>
        We’re rolling out some changes and want everything to be perfect. Hang tight, we'll be back
        in just a bit.
      </Typography>
    </Box>
  );
}
